import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './startupForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { setModoTela, initForm, salvar, excluir, getLista } from './startupActions';
import ContentCardFooter from '../common/template/contentCardFooter';
import Background from '../common/template/background';
import DateFormat from '../common/dateFormat/DateFormat';
import { getLista as getListaTexto } from '../texto/textoActions';
import TextoInput from '../texto/textoInput';

class Startup extends Component {

	state = {
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaTexto();
    }

    render() {

        return (
			<>
				<div 
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'center',
						flexWrap: 'wrap',
						backgroundColor: '#0F2748',
						width: '100%',
						padding: 16,
						color: '#ffffff'
					}}>
					<h2 style={{ fontSize: 'clamp(0.8rem, 2.5vw, 1.5rem)', margin: 0, padding: 0 }}>{this.props.startupTitulo}</h2>
					
					<TextoInput chave='startupTitulo' />
				</div>

				<Background
					backgroundPosition={'center'}
					gradientStart='#0F2748'
					gradientEnd='#19CCCC'>
					<Content>
						<Aguardando aguardando={this.props.aguardando} />

						{this.props.modoTela == 'cadastro' ? (
							<Form onSubmit={this.props.salvar} />
						) : null}
						{this.props.modoTela == 'visualizacao' ? (
							<Form visualizacao onSubmit={this.props.salvar} />
						) : null}
						{this.props.modoTela == 'exclusao' ? (
							<Form excluir onSubmit={this.props.excluir} />
						) : null}
						{this.props.modoTela == 'lista' ? this.lista() : null}
					</Content>
				</Background>
			</>
        )
    }

	lista() {

		let lista = this.props.lista;

		let tamanho = (250 * window.innerWidth) / 1600;
		if (tamanho > 250) {
			tamanho = 250;
		} else if (tamanho < 85) {
			tamanho = 85;
		}

		return (
			<Row alignCenter>
				{this.props.sessao.administrador &&
				<Grid cols='12 6 4 3'>
					<Button
						text='Adicionar'
						type={'primary'}
						icon={'fa fa-plus'}
						event={() => {
							this.props.setModoTela('cadastro', {});
							this.props.initForm({});
						}} />
				</Grid>}

				<Grid cols='12 12 12 12'>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							flexWrap: 'wrap',
							justifyContent: 'center'
						}}>
						{lista.map(item => (
							<div
								style={{ 
									backgroundColor: '#53c3bb',
									display: 'flex',
									flexDirection: 'column',
									margin: 8,
									backgroundColor: '#ffffff',
									borderRadius: '5%'
								}}>
								<a href={item.link} target='_blank' 
									style={{
										display: 'flex',
										flexDirection: 'column',
										justifyContent: 'center',
										alignItems: 'center',
										width: tamanho,
										height: tamanho,
										padding: 16
									}}>
									<img 
										style={{
											width: 'auto',
											maxWidth: '100%',
											height: 'auto',
											maxHeight: '100%'
										}}
										src={item.imagem}
										title={item.nome}>
									</img>
								</a>

								{this.props.sessao.administrador &&
								<div style={{ margin: 4, width: '100%', textAlign: 'center'}}>
									<ButtonTable
										type={'primary'}
										icon={'fas fa-pencil-alt'}
										visible={true}
										event={() => {
											this.props.setModoTela('cadastro', {
												...item
											});
											this.props.initForm({
												...item
											});
										}} />

									<ButtonTable
										type={'danger'}
										icon={'fas fa-trash'}
										visible={true}
										event={() => {
											this.props.setModoTela('exclusao', {
												...item
											});
											this.props.initForm({
												...item
											});
										}} />
								</div>}
							</div>
						))}
					</div>
				</Grid>
			</Row>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.startup.modoTela,
	aguardando: state.startup.aguardando,
	lista: state.startup.lista,
	startupTitulo: state.texto.lista.filter(item => item.chave == 'startupTitulo').map(item => item.valor)[0]
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista,
	getListaTexto
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Startup);
